import { render, staticRenderFns } from "./VMC33rdAnniversary.vue?vue&type=template&id=54934a40&scoped=true"
import script from "./VMC33rdAnniversary.vue?vue&type=script&lang=js"
export * from "./VMC33rdAnniversary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54934a40",
  null
  
)

export default component.exports